import { useState } from "react";
import { VoiceAssistantActionContainer } from "./VoiceAssistantActionContainer";
import { VoiceAssistantTranscribe } from "./VoiceAssistantTranscribe";
import CaptionIcon from "../atoms/images/CaptionIcon.jsx";
import CaptionFillIcon from "../atoms/images/CaprionFillIcon.jsx";
import { CaptionStreamBinder } from "./CaptionStreamBinder";
import { useMicVolume } from "../../hooks/useMicVolume";
import { useSpeakingPulse } from "../../hooks/useSpeakingPulse";
import { agentSpeakStatus } from "../../services/voiceService.js";

export const VoiceAssistantContainer = () => {
    const [isCaptionActive, setIsCaptionActive] = useState(false);

    const { volume, levelDb, permission, error } = useMicVolume({
        autostart: true,
        gateDb: -55,
        attackMs: 60,
        releaseMs: 220,
    });

    // Merge states → a single pulse + who’s speaking
    const { pulseScale, speaking } = useSpeakingPulse(
        volume,
        agentSpeakStatus()
    );

    // Colors by state: client = blue, agent = green, idle = gray/black
    const circleColor =
        speaking === "client"
            ? "linear-gradient(110.39deg, rgba(0, 33, 71, 0.95) 32.09%, rgba(223, 28, 1, 0.95) 133.29%)"
            : speaking === "agent"
            ? "linear-gradient(110.39deg, rgba(0, 33, 71, 0.95) 32.09%, rgba(223, 28, 1, 0.95) 133.29%)"
            : "linear-gradient(110.39deg, rgba(0, 33, 71, 0.95) 32.09%, rgba(223, 28, 1, 0.95) 133.29%)";

    return (
        <div className="va-container">
            <div
                style={{ position: "absolute", right: "0", cursor: "pointer" }}
                onClick={() => {
                    setIsCaptionActive(!isCaptionActive);
                }}
            >
                {isCaptionActive ? <CaptionFillIcon /> : <CaptionIcon />}
            </div>
            <div
                className={`circle ${speaking !== "idle" ? "animated" : ""}`}
                style={{
                    height: isCaptionActive ? "100px" : "150px",
                    width: isCaptionActive ? "100px" : "150px",
                    background:
                        permission === "denied"
                            ? "repeating-linear-gradient(45deg, #aaa 0 6px, #bbb 6px 12px)"
                            : circleColor,
                    transform: `scale(${pulseScale})`,
                    transition:
                        "transform 0.12s ease-out, background 0.2s ease",
                    boxShadow:
                        speaking === "idle"
                            ? "none"
                            : `0 0 24px rgba(0,0,0,0.12), 0 0 32px ${circleColor}55`,
                }}
            />

            {isCaptionActive && <VoiceAssistantTranscribe />}
            <CaptionStreamBinder />
            <VoiceAssistantActionContainer />
        </div>
    );
};
